module.exports = __webpack_public_path__ + "static/media/logo_ta.71e9bee5.webp";